export const DividerDateOverdueComponent = {
  bindings: {},
  templateUrl: 'components/Divider/divider-date/divider-date-overdue.html',
};
